document.addEventListener('DOMContentLoaded', function () {
    const desktopMq = window.matchMedia('(min-width: 990px)');

    const initMegaMenu = () => {
        const megaMenus = document.querySelectorAll('[data-mega-menu]');

        megaMenus.forEach((details) => {
            const summary = details.querySelector('summary');
            const content = details.querySelector('[data-mega-content]');
            if (!summary || !content) return;

            // 1. Клік по заголовку -> перехід, а не відкриття (тільки десктоп)
            summary.addEventListener('click', function (e) {
                if (!desktopMq.matches) return; // на мобі залишаємо стандартну поведінку

                e.preventDefault();
                const href = summary.getAttribute('data-main-href');
                if (href && href !== '-1') {
                    window.location.href = href;
                }
            });

            // 2. Hover відкриває / закриває меню (тільки десктоп)
            details.addEventListener('mouseenter', function () {
                if (!desktopMq.matches) return;
                details.setAttribute('open', '');
            });

            // 3. Вихід миші з усього блока (summary + контент) закриває меню
            details.addEventListener('mouseleave', function () {
                if (!desktopMq.matches) return;
                details.removeAttribute('open');
            });

            // 4. Клік по хрестику всередині
            const closeBtn = content.querySelector('[data-mega-close]');
            if (closeBtn) {
                closeBtn.addEventListener('click', function () {
                    details.removeAttribute('open');
                });
            }
        });
    };

    initMegaMenu();
    desktopMq.addEventListener('change', initMegaMenu);
});
